import * as Sentry from '@sentry/browser'
import { initialize as initializeBombBomb } from 'src/vendor/bombBomb'

import {
  BOMBBOMB_INITIALIZE,
  BOMBBOMB_ERROR,
  BOMBBOMB_MOUNT,
  BOMBBOMB_TOGGLE_OPEN
} from './actionTypes'

const initializeScript = apiKey => async dispatch => {
  if (!process.env.REACT_APP_SSO_API_URL) {
    return // Use for launch key on bomb bomb
  }

  await initializeBombBomb(apiKey, {
    onError: error => dispatch(setBombBombError(error))
  })

  dispatch({
    type: BOMBBOMB_INITIALIZE
  })
}

export const initialize = ({ providers = [] }) => dispatch => {
  const { apiKey } = providers.find(({ name }) => name === 'bomb_bomb') || {}

  if (!apiKey) {
    return
  }

  dispatch(initializeScript(apiKey))
}

export const setBombBombError = error => dispatch => {
  Sentry.captureException(error)

  dispatch({
    type: BOMBBOMB_ERROR,
    error
  })
}

export const toggleBombBomb = () => (dispatch, getState) => {
  const {
    bombBomb: { mount, error }
  } = getState()

  if (!mount && !error) {
    return dispatch({
      type: BOMBBOMB_MOUNT
    })
  }

  dispatch({
    type: BOMBBOMB_TOGGLE_OPEN
  })
}
